import { warnAboutMissingStyles } from '@entur/utils';
import React from 'react';
import classNames from 'classnames';
import { Heading5, SmallText } from '@entur/typography';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var _excluded$6 = ["children", "className", "progress"];
var Loader = function Loader(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$progress = _ref.progress,
    progress = _ref$progress === void 0 ? 'indeterminate' : _ref$progress,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var isIndeterminate = progress === 'indeterminate';
  var styles = {};
  if (!isIndeterminate) {
    styles = {
      '--loader-width': progress + "%"
    };
  }
  return React.createElement("div", _extends({
    className: classNames('eds-loader', className),
    role: "alert",
    "aria-busy": true,
    "aria-live": "polite"
  }, rest), children && React.createElement(Heading5, {
    as: "div",
    className: "eds-loader__label"
  }, children), React.createElement("div", {
    className: classNames('eds-loader__bar', {
      'eds-loader__bar--indeterminate': isIndeterminate
    }),
    style: styles
  }), progress !== 'indeterminate' && React.createElement(SmallText, {
    className: "eds-loader__percentage"
  }, progress, " %"));
};
var _excluded$5 = ["className", "style"];
var BaseSkeleton = function BaseSkeleton(_ref) {
  var className = _ref.className,
    style = _ref.style,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return React.createElement("div", _extends({
    className: classNames('eds-skeleton', 'eds-skeleton--animate', className),
    role: "alert",
    "aria-busy": true,
    "aria-live": "polite",
    style: style
  }, rest));
};
var _excluded$4 = ["className", "width", "height"];
var SkeletonRectangle = function SkeletonRectangle(_ref) {
  var className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return React.createElement(BaseSkeleton, _extends({
    className: classNames('eds-skeleton-rectangle', className),
    style: _extends({
      width: width,
      height: height
    }, rest.style)
  }, rest));
};
var _excluded$3 = ["className", "size"];
var SkeletonCircle = function SkeletonCircle(_ref) {
  var className = _ref.className,
    size = _ref.size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React.createElement(BaseSkeleton, _extends({
    className: classNames(className, 'eds-skeleton-circle'),
    style: _extends({
      width: size,
      height: size
    }, rest.style)
  }, rest));
};
var _excluded$2 = ["className", "children", "loadingAriaLabel"];
var SkeletonWrapper = function SkeletonWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$loadingAriaLabel = _ref.loadingAriaLabel,
    loadingAriaLabel = _ref$loadingAriaLabel === void 0 ? 'Laster inn innhold …' : _ref$loadingAriaLabel,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return React.createElement("div", _extends({
    className: classNames('eds-skeleton-wrapper', className),
    role: "alert",
    "aria-busy": true,
    "aria-live": "polite",
    "aria-label": loadingAriaLabel
  }, rest), children);
};
var _excluded$1 = ["color", "className"];
var LoadingDots = function LoadingDots(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return React.createElement("div", _extends({
    className: classNames('eds-loading-dots', "eds-loading-dots--color-" + color, className),
    style: _extends({}, rest.style)
  }, rest), React.createElement(LoadingDot, {
    dotNumber: "one"
  }), React.createElement(LoadingDot, {
    dotNumber: "two"
  }), React.createElement(LoadingDot, {
    dotNumber: "three"
  }));
};
var LoadingDot = function LoadingDot(_ref2) {
  var dotNumber = _ref2.dotNumber;
  return React.createElement("span", {
    className: classNames('eds-loading-dots__dot', "eds-loading-dots__dot--" + dotNumber)
  });
};
var _excluded = ["className"];
var Spinner = function Spinner(_ref) {
  var className = _ref.className,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(React.Fragment, null, React.createElement("div", _extends({
    className: classNames('eds-spinner', className),
    style: _extends({}, rest.style)
  }, rest)));
};
warnAboutMissingStyles('loader', 'typography');
export { Loader, LoadingDots, SkeletonCircle, SkeletonRectangle, SkeletonWrapper, Spinner };